export default __webpack_public_path__ + "static/media/record-store-open.003986e5.png";